import { createContext, useContext } from "react";
import { LearnContextProps, QuizAttempt } from "./learn.interface";

const noop = () => {};

const LearnContext = createContext<LearnContextProps>({
  activeQuizzes: undefined,
  quizzes: undefined,
  quizTracker: undefined,
  nextQuestion: undefined,
  quizIndex: -1,
  activeQuizSubmissions: undefined,
  currentQuizQuestionsWithDetails: undefined,
  quizStartTime: undefined,
  quizStatus: undefined,
  getAuthUserPoolQuiz: noop,
  getPoolQuizzes: noop,
  getPoolQuizQuestion: noop,
  answerQuizQuestion: noop,
  getQuizResultsBySubmissionId: noop,
  updateQuizIndex: noop,
  setQuizIndex: noop,
  resetLearnState: noop,
  resetQuizState: noop,
  clearPreviousAttempt: noop,
  setQuizAttempt: function (quizAttempt: QuizAttempt): void {
    throw new Error("Function not implemented.");
  },
  hasFailed: function (poolId: string): boolean {
    throw new Error("Function not implemented.");
  }
});


export const useLearnContext = () => useContext(LearnContext);

export default LearnContext;